import { useState } from "react";
import Header from "../components/Header";
import { CFormInput, CLoadingButton } from "@coreui/react-pro";
import { ToastInfo } from "@/components/shared/toast/Toast";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/reducers";
import { AppDispatch } from "@/store";
import { formatMoney } from "@/shared/utils/ultils";
import axios from "@/shared/config/axios-interceptor";
import { getProfile } from "../../auth/auth.api";
import { useTranslation } from "react-i18next";
const RutTien = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();
  const { user } = useSelector((state: RootState) => state.authentication);
  const [loading, setLoading] = useState(false);
  const [amount, setAmount] = useState("");
  const [paypassword, setPaypassword] = useState("");

  const onSubmit = async () => {
    if (!amount || !paypassword) {
      ToastInfo(t("Vui lòng nhập đầy đủ thông tin!"));
      return;
    }

    if (!user?.bankName) {
      ToastInfo(t("Vui lòng liên kết ngân hàng ngay!"));
      return;
    }

    if (isNaN(Number(amount)) || amount.trim() === "") {
      ToastInfo(t("Vui lòng nhập số tiền hợp lệ"));
      return;
    }

    if (Number(amount) <= 0) {
      ToastInfo(t("Số tiền phải lớn hơn 0"));
      return;
    }

    try {
      setLoading(true);
      await axios.post("/transaction/withdraw", {
        money: Number(amount),
        paypassword,
      });
      ToastInfo(t("Gửi rút tiền thành công"));
      setAmount("");
      dispatch(getProfile());
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  const get4SoCuoiCardNumber = () => {
    return user?.cardNumber?.slice(-4);
  };
  return (
    <div className="wrapper">
      <div className="container-web ruttien bgnew">
        <div className="header-account">
          <Header title={t("Rút tiền")} />
          <div
            style={{ height: 130, alignContent: "center", textAlign: "center" }}
          >
            <div style={{ fontSize: 12, color: "#999" }}>
              {t("Số dư có thể rút")}
            </div>
            <div className="mt-2 mb-3" style={{ fontSize: 24 }}>
              {formatMoney(user?.money)}
            </div>
          </div>
        </div>

        <div
          className="p-3 d-flex justify-content-between align-items-center"
          style={{ background: "#222", fontSize: 14 }}
        >
          <Link
            to="/them-tai-khoan-ngan-hang"
            className="text-white text-decoration-none"
          >
            {user?.bankName ? (
              <>
                <div>{user?.bankName}</div>
                <div style={{ color: "#dfc6a0", fontSize: 12 }}>
                  {t("Bốn chữ số cuối cùng")}: {get4SoCuoiCardNumber()}
                </div>
              </>
            ) : (
              <div className="d-flex align-items-center gap-2 text-white text-decoration-none">
                <i className="fa-solid fa-circle-info text-warning"></i>
                {t("Liên kết ngân hàng ngay")}
              </div>
            )}
          </Link>
          <i className="fa-solid fa-chevron-right"></i>
        </div>

        <div className="form-group">
          <CFormInput
            label={t("Số tiền rút")}
            placeholder={t("Vui lòng nhập số tiền rút")}
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>

        <div className="form-group">
          <CFormInput
            type="password"
            label={t("Mật khẩu rút tiền")}
            placeholder={t("Vui lòng nhập mã rút tiền")}
            value={paypassword}
            onChange={(e) => setPaypassword(e.target.value)}
          />
        </div>

        <div className="px-3 mt-4">
          <CLoadingButton
            onClick={onSubmit}
            className="w-100 rounded-1"
            loading={loading}
            disabled={loading}
          >
            {t("Rút tiền")}
          </CLoadingButton>
        </div>

        <div className="text-center mt-4">
          <Link
            to={"/them-tai-khoan-ngan-hang"}
            style={{ color: "#d5b377", fontSize: 14 }}
            className="text-decoration-none text-center"
          >
            {t("Xem tài khoản của tôi")}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default RutTien;
